import React from 'react';
import './TypingIndicator.css';

interface TypingIndicatorProps {
  message?: string;
}

/**
 * ChatGPT-style typing indicator with animated dots
 */
export function TypingIndicator({ message }: TypingIndicatorProps) {
  return (
    <div className="typing-indicator">
      <div className="typing-dots">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
      {message && <span className="typing-message">{message}</span>}
    </div>
  );
}

export default TypingIndicator;
